module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/live-count.705ef21d.svg";